import HtmlBlock from '~/components/Helpers/HtmlBlock'
import PrimaryCTA from '~/components/UI/Buttons/PrimaryCTA/PrimaryCTA'
import SecondaryCTA from '~/components/UI/Buttons/SecondaryCTA/SecondaryCTA'
import TertiaryLink from '~/components/UI/Buttons/TertiaryLink/TertiaryLink'

import SearchAutocomplete from '~/components/Content/SearchAutocomplete/SearchAutocomplete'
import MarkDown from '~/components/Helpers/MarkDown'

import { useSearchAutocomplete } from '~/hooks/useAutocompleteSearch'

export interface GenContProps {
  content: {
    eyebrow?: string
    heading?: string
    copy?: string
    uiSearch: {
      placeholder?: string
      contentType?: Array<{ id: string }>
      keyword?: string
    }
    ctaButtons?: boolean
    buttons?: {
      label: string
      mobileLabel: string
      entry: { sys: { uri: string } }
    }[]
    sys?: { id?: string }
  }
  layoutColour?: AllBackgroundColours
  type?: 'Default' | 'Outline' | 'Minimal' | null | undefined
}

const SearchBlock = ({
  content,
  layoutColour,
  type = 'Outline'
}: GenContProps) => {
  const {
    eyebrow,
    heading,
    copy,
    uiSearch,
    buttons,
    ctaButtons = true
  } = content

  const { mappedItems, isSuccess, handleQueryChange } = useSearchAutocomplete([
    uiSearch
  ])

  return (
    <section>
      <div className='space-y-m md:space-y-l'>
        <div className='space-y-xs-plus'>
          {eyebrow && <p className='tag'>{eyebrow}</p>}
          <MarkDown content={'## ' + heading} />
          {copy && <HtmlBlock content={copy} />}
        </div>
        <div className='text-blue-d relative flex items-center'>
          <SearchAutocomplete
            placeholder={uiSearch?.placeholder || 'Search...'}
            type={type}
            disabled={false}
            data={{
              label: '',
              note: ''
            }}
            loading={isSuccess}
            items={mappedItems}
            onQueryChange={handleQueryChange}
          />
        </div>

        {buttons && buttons.length > 0 && (
          <div className='gap-m flex flex-wrap'>
            {buttons && (
              <div className='gap-xs xl:gap-s flex flex-wrap'>
                {ctaButtons ? (
                  <>
                    {buttons && buttons?.length <= 2 && (
                      <>
                        <PrimaryCTA
                          data={buttons[0]}
                          colour={
                            ['ink-blue', 'mid-blue'].includes(
                              layoutColour ?? ''
                            )
                              ? 'white'
                              : 'ink-blue'
                          }
                        />
                        {buttons && buttons?.length > 1 && (
                          <SecondaryCTA
                            data={buttons[1]}
                            colour={
                              ['ink-blue', 'mid-blue'].includes(
                                layoutColour ?? ''
                              )
                                ? 'white'
                                : 'ink-blue'
                            }
                          />
                        )}
                      </>
                    )}
                    {buttons &&
                      buttons?.length > 2 &&
                      buttons.map((link, index: Index) => (
                        <TertiaryLink
                          data={link}
                          key={index}
                          colour={
                            ['ink-blue', 'mid-blue'].includes(
                              layoutColour ?? ''
                            )
                              ? 'white'
                              : 'ink-blue'
                          }
                        />
                      ))}
                  </>
                ) : (
                  <>
                    {buttons &&
                      buttons.map((link, index: Index) => (
                        <TertiaryLink
                          data={link}
                          key={index}
                          colour={
                            ['ink-blue', 'mid-blue'].includes(
                              layoutColour ?? ''
                            )
                              ? 'white'
                              : 'ink-blue'
                          }
                        />
                      ))}
                  </>
                )}
              </div>
            )}
          </div>
        )}
      </div>
    </section>
  )
}

export default SearchBlock
